import styled from 'styled-components';

import theme from '@styles/theme';

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 80px;
    width: 100%;
    height: calc(100vh - 80px);
`;
export const Title = styled.h2`
    margin: 0 0 12px;
    font-family: PretendardBold, sans-serif;
    font-size: 24px;
`;
export const SubTitle = styled.div`
    font-size: 16px;
    color: ${theme.colors.lightGrayFontColor};
`;
